/*let playButton = $(".hero-block__play-btn"),
	videoModal = $(".hero-block__modal"),
	videoModalWrapper = $(".hero-block__modal-wrapper"),
	videoModalPlayer = $(".hero-block__modal-wrapper video"),
	closeModal = $(".hero-block__modal_close");

playButton.on("click", function() {
	$("body").addClass("fix");
	videoModal.fadeIn();
	let videoURL;
	if (videoModal.hasClass("external-video")) {
		videoURL = $(".hero-block__modal-wrapper .video-container iframe").attr(
			"src"
		);
		videoURL += "&autoplay=1";
		setTimeout(() => {
			$(".hero-block__modal-wrapper iframe").attr("src", videoURL);
		}, 400);
	} else {
		videoModalPlayer.get(0).play();
	}
});
closeModal.on("click", function() {
	$("body").removeClass("fix");
	videoModal.fadeOut();
	if (videoModal.hasClass("external-video")) {
		$(".hero-block__modal-wrapper iframe").attr(
			"src",
			$(".hero-block__modal-wrapper .video-container").attr("data-src")
		);
	} else {
		videoModalPlayer.get(0).pause();
		videoModalPlayer.get(0).currentTime = 0;
	}
});

videoModal.on("click", function(e) {
	if ($(e.target).is(this) || $(e.target).is(videoModalWrapper)) {
		$("body").removeClass("fix");
		videoModal.fadeOut();
		if (videoModal.hasClass("external-video")) {
			$(".hero-block__modal-wrapper iframe").attr(
				"src",
				$(".hero-block__modal-wrapper .video-container").attr("data-src")
			);
		} else {
			videoModalPlayer.get(0).pause();
			videoModalPlayer.get(0).currentTime = 0;
		}
	}
});
*/



// WEBPACK FOOTER //
// ./scripts/modules/hero-block.js